class BoxProduct extends HTMLElement {
  constructor() {
    super();
    this.checkbox = null;
    this.form = null;
    this.variantInput = null;
    this.variantPrice = null;
    this.productInfoContainer = this.closest("product-info");
    this.imageUrl = this.querySelector("img");
    this.imageContainer = this.closest(".product")?.querySelector(".product-main-image");
    if(this.productInfoContainer){
      this.priceContainer = this.productInfoContainer.querySelector(".price-item.main-price");
    }else{
      this.priceContainer = null;
    }
  }

  connectedCallback() {
    this.checkbox = this.querySelector('input[type="checkbox"]');
    if (!this.checkbox) return;
    console.log("this.checkbox")
    

    const formId = this.dataset.form;
    const linkedVariantId = this.dataset.id;
    const originalVariantId = this.dataset.productId;
    const variantPrice = this.dataset.price;

    setTimeout(()=>{
      this.checkbox.checked = false;
      this.checkbox.dispatchEvent(new Event("change"))
    },100)

    if (!formId || !linkedVariantId || !originalVariantId) return;

    this.form = document.getElementById(formId);
    if (!this.form) return;

    this.form.addEventListener("submit", ()=> {
      setTimeout(()=>{
        this.checkbox.checked = false;
        this.checkbox.dispatchEvent(new Event("change"))
      },100)
    })

    this.variantInput = this.form.querySelector('input[name="id"]');
    if (!this.variantInput) return;

    this.variantPrice = variantPrice;
    if (!this.variantPrice) return;

    if (!this.priceContainer) return;
    

    this.checkbox.addEventListener("change", () => {
       const value = this.checkbox.checked
        ? linkedVariantId
        : originalVariantId;

      const price = this.checkbox.checked
        ? this.variantPrice
        : this.priceContainer.dataset.price;

       const addImage = this.checkbox.checked;

        this.updateVariantInput(value, price, addImage);
    });
  }

  updateVariantInput(value, price, addImage) {
  // console.log("kkk")
    
    // update variant id
    this.variantInput.value = value;
    this.variantInput.setAttribute("value", value);

    // Update price
    this.priceContainer.textContent = price;

    // Update the image
    if(addImage){
      if(!this.imageContainer.querySelector("img.bundle-image")){
        if(this.imageUrl){

          const img = document.createElement("img");
          img.src = this.imageUrl.src;
          img.classList.add("bundle-image");
          
          if(this.imageContainer){
            const ogImage = this.imageContainer.querySelector("img");
            ogImage.classList.add("hidden");
            this.imageContainer.append(img);
          }
        }

      }else{
        this.imageContainer.querySelector("img").classList.add("hidden");
        this.imageContainer.querySelector("img.bundle-image").classList.remove("hidden");
      }
    }else{
      if(this.imageContainer){
        const ogImage = this.imageContainer.querySelector("img");
        ogImage.classList.remove("hidden");
        const bundleImage = this.imageContainer.querySelector(".bundle-image")

        if(bundleImage){
          bundleImage.classList.add("hidden")
        }
        
      }
    }

    // Notify Shopify/theme listeners
    this.variantInput.dispatchEvent(
      new Event("change", { bubbles: true })
    );
  }
}

customElements.define("box-product", BoxProduct);

window.addEventListener("pageshow", (e) => {
  if (e.persisted) {
   setTimeout(()=> {
     document
      .querySelectorAll('box-product input[type="checkbox"]')
      .forEach(cb => cb.checked = false);
   }, 10)
  }
});
